import { put, all, takeEvery, takeLatest, select } from "redux-saga/effects";

import * as selectors from "state/teachers/selectors";
import * as actions from "state/teachers/actions";
import { PROCESS_METADATA } from "state/app/actions";

import fetchAllSaga from "state/teachers/sagas/fetchAll";
import fetchSchoolsSaga from "state/teachers/sagas/fetchSchools";
import fetchMessagesSaga from "state/teachers/sagas/fetchMessages";
import mergeMessagesSaga from "state/teachers/sagas/mergeMessages";
import fetchNoticesSaga from "state/teachers/sagas/fetchNotices";
import fetchTermsSaga from "state/teachers/sagas/fetchTerms";
import sendReplySaga from "state/teachers/sagas/sendReply";
import processMetadataSaga from "state/teachers/sagas/processMetadataSaga";
import goToMessageSaga from "state/teachers/sagas/goToMessageSaga";
import goToNoticeSaga from "state/teachers/sagas/goToNoticeSaga";
import markMessagesReadSaga from "state/teachers/sagas/markMessagesReadSaga";

export default function* teachersRootSaga() {

  // start sub-sagas
  yield all([
    takeEvery(actions.FETCH_ALL, fetchAllSaga),
    takeLatest(actions.FETCH_SCHOOLS, fetchSchoolsSaga),
    takeLatest(actions.FETCH_MESSAGES, fetchMessagesSaga),
    takeLatest(actions.FETCH_SCHOOLS_COMPLETED, mergeMessagesSaga),
    takeLatest(actions.FETCH_MESSAGES_COMPLETED, mergeMessagesSaga),
    takeLatest(actions.FETCH_NOTICES, fetchNoticesSaga),
    takeLatest(actions.FETCH_TERMS, fetchTermsSaga),
    takeEvery(actions.SEND_REPLY, sendReplySaga),
    takeEvery(PROCESS_METADATA, processMetadataSaga),
    takeEvery(actions.GO_TO_MESSAGE, goToMessageSaga),
    takeEvery(actions.GO_TO_NOTICE, goToNoticeSaga),
    takeEvery(actions.MARK_SCHOOL_MESSAGES_READ, markMessagesReadSaga)
  ]);
  
  // load initial data
  yield put(actions.fetchAll());

  // Get the guideShownDate. If it's not defined, open the guide.
  const guideShownDate = yield select(selectors.getGuideShownDate);
  if (guideShownDate === undefined) {
    yield put( actions.openGuide() );
  }

}



// WEBPACK FOOTER //
// ./src/state/teachers/sagas/index.js